import { api } from "@/lib/api";
import { idb } from "@/lib/offlineDb";

const listeners = new Set();
export const onQueueChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
const notify = async () => {
  const n = (await idb.all("queue")).length;
  listeners.forEach((f) => f(n));
};

export const todayUTC = () => new Date().toISOString().slice(0, 10);
export const pendingCount = async () => (await idb.all("queue")).length;

const ENDPOINTS = {
  lesson_complete: "/lessons/complete",
  assessment_submit: "/assessments/submit",
  review_add: "/review/add",
  review_answer: "/review/answer",
};

export async function enqueue(kind, payload) {
  await idb.set("queue", null, { kind, payload: { ...payload, activity_date: todayUTC() } });
  notify();
}

export async function postOrQueue(kind, payload) {
  try {
    return (await api.post(ENDPOINTS[kind], payload)).data;
  } catch (e) {
    if (e?.response) throw e;
    await enqueue(kind, payload);
    return null;
  }
}

let syncing = false;
export async function syncQueue() {
  if (syncing || !navigator.onLine) return 0;
  syncing = true;
  let done = 0;
  try {
    const items = (await idb.all("queue")).sort((a, b) => a.id - b.id);
    for (const it of items) {
      try {
        await api.post(ENDPOINTS[it.kind], it.payload);
        done += 1;
      } catch (e) {
        if (!e.response) break;
      }
      await idb.del("queue", it.id);
    }
  } finally {
    syncing = false;
    notify();
  }
  return done;
}
